import { Component, Input } from '@angular/core';
import { ReportBuilderService } from '../report-builder.service';
import { SchemaObject,TableColumn } from '../openapi-schema';

@Component({
    selector: 'app-dynamic-section',
    templateUrl: './dynamic-section.component.html',
    styleUrls: ['./dynamic-section.component.scss'],
    standalone: false
})
export class DynamicSectionComponent {
  @Input() schema!: SchemaObject;
  @Input() data: any;
  
  metadataColumns: any[] = [];
  childSchema: SchemaObject | null = null;
  sectionType: 'metadata' | 'table' = 'metadata';

  constructor(private reportService: ReportBuilderService) {}

  ngOnInit() {
    if (this.schema.type === 'object' && this.schema.properties) {
      this.sectionType = 'metadata';
      this.metadataColumns = this.reportService.getMetadataSections(this.schema);
    } 
    else if (this.schema.type === 'array' && this.schema.items) {
      this.sectionType = 'table';
      this.childSchema = this.schema.items as SchemaObject;
    }
  }

  getValue(data: any, path: string): any {
    return this.reportService.getValue(data, path);
  }
}
